// extracted by mini-css-extract-plugin
export var menu = "Menu-module--menu--68e64";